import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Licenses")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Databases ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Invoices ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Referral program ")
const _hoisted_6 = { class: "credits" }
const _hoisted_7 = { class: "balance" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Credits: ")

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CheckCircleOutlined = _resolveComponent("CheckCircleOutlined")
  const _component_router_link = _resolveComponent("router-link")
  const _component_a_menu_item = _resolveComponent("a-menu-item")
  const _component_PlusCircleOutlined = _resolveComponent("PlusCircleOutlined")
  const _component_FileDoneOutlined = _resolveComponent("FileDoneOutlined")
  const _component_ShareAltOutlined = _resolveComponent("ShareAltOutlined")
  const _component_a_menu = _resolveComponent("a-menu")

  return (_ctx.store.state.auth.isAuthenticated)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode(_component_a_menu, {
          mode: "inline",
          style: {"width":"256px"},
          selectedKeys: _ctx.selectedKeys
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_menu_item, { key: "Home" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: "/" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CheckCircleOutlined),
                    _hoisted_2
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, { key: "Databases" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, {
                  id: "test",
                  to: "/databases"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_PlusCircleOutlined),
                    _hoisted_3
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, { key: "Invoices" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: "/invoices" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_FileDoneOutlined),
                    _hoisted_4
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, { key: "Referral" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: "/referral" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ShareAltOutlined),
                    _hoisted_5
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["selectedKeys"]),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode("span", null, _toDisplayString(_ctx.converter(_ctx.credits)), 1)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}